import React from 'react';

export default function DesignSection({ id, title, subtitle, style, children }) {
  return (
    <div id={id} className="medium-bottom-margin max-width-container full-width" style={style}>
      <div className="small-padding">
        <h3>{title}</h3>
        {subtitle && <p className="subheading" style={{ marginTop: '6px' }}>{subtitle}</p>}
      </div>
      <div className="small-padding" style={{paddingTop:'0px'}}>
        {children}
      </div>
    </div>
  );
}
